import React, { useState } from "react";
import "./style.css";
import { AiOutlineUser } from "react-icons/ai";
import { TbRobot } from "react-icons/tb";
import { BsVolumeUp, BsVolumeUpFill } from "react-icons/bs";
import Typewriter from "typewriter-effect";
import MultipleChoiceQuestion from "./MultipleChoiceQuestion";
import Text from "./Text.js";
import Feedback from "./Feedback";

const Chat = ({ message, scrollToBottom }) => {
    const [isSpeaking, setIsSpeaking] = useState(false);
    const disclaimer =
        "Disclaimer: cuGPT is a beta product, and may use chatGPT, youchat, bard and other generative AI's to create output. The output from AI may not be accurate. When in doubt, please consult course staff for clarification. Also provide ratings, and feedback for the generative AI outputs so we can improve the cuGPT feature. Thank you for helping us expand the capabilities of cubits videos using generative AI.";

    const speakText = (text) => {
        if (!('speechSynthesis' in window)) {
            return;
        }

        // Stop any currently playing speech
        window.speechSynthesis.cancel();
        
        if (isSpeaking) {
            setIsSpeaking(false);
            return;
        }

        const utterance = new SpeechSynthesisUtterance(text);
        utterance.rate = 1.0;
        utterance.pitch = 1.0;
        utterance.lang = 'en-US';

        utterance.onend = () => {
            setIsSpeaking(false);
        };

        utterance.onerror = () => {
            setIsSpeaking(false);
        };

        window.speechSynthesis.speak(utterance);
        setIsSpeaking(true);
    };

    if (message.user == "GPT") {
        return (
            <div>
                <div className="GPT-box">
                    <div className="icon">
                        <TbRobot id="GPT-icon" size={20} />
                    </div>
                    <div className="message-content">
                        {!message.mcq ? (
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <Text message={message.content} />
                                    {message.imageUrl && (
                                        <img 
                                            src={message.imageUrl} 
                                            alt="Generated plot"
                                            className="cugpt-plot-image"
                                            onError={(e) => {
                                                console.error("Failed to load plot image:", message.imageUrl);
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    )}
                                </div>
                                <button
                                    type="button"
                                    onClick={() => speakText(message.content)}
                                    className={`voice-output-button ${isSpeaking ? 'speaking' : ''}`}
                                    title="Read aloud">
                                    {isSpeaking ? (
                                        <BsVolumeUpFill size={18} color="rgba(30, 112, 105, 0.9)" />
                                    ) : (
                                        <BsVolumeUp size={18} color="black" />
                                    )}
                                </button>
                            </div>
                        ) : (
                            <MultipleChoiceQuestion
                                data={message.content}
                                scrollToBottom={scrollToBottom}
                            />
                        )}
                    </div>
                </div>

                {(message.element === 2 || message.element === 3) &&
                    message.elementId &&
                    message.elementId !== -1 && (
                        <div className="feedback">
                            <Feedback
                                element={message.element}
                                elementId={message.elementId}
                            />
                        </div>
                    )}
            </div>
        );
    } else if (message.user == "USER") {
        return (
            <div className="user-box">
                <AiOutlineUser id="user-icon" size={17} />
                <div className="message-content">{message.content}</div>
            </div>
        );
    } else if (message.user == "WELCOME") {
        return (
            <div>
                <div className="GPT-box">
                    <div className="icon">
                        <TbRobot id="GPT-icon" size={20} />
                    </div>

                    <div className="message-content">
                        <Typewriter
                            onInit={(typewriter) => {
                                typewriter.typeString(message.content).start();
                            }}
                            options={{
                                delay: 30
                            }}
                        />

                        <div id="disclaimer">{disclaimer}</div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Chat;
